import React, { useCallback, useEffect } from 'react';
import { useBodyLock } from '../hooks/useReveal';
import { ArrowRight, Close } from './Icons';
import './Lightbox.css';

export default function Lightbox({ items, index, onClose, onIndex }) {
  const open = index !== null && index !== undefined;
  useBodyLock(open);

  const step = useCallback(
    (delta) => {
      if (!open) return;
      const next = (index + delta + items.length) % items.length;
      onIndex(next);
    },
    [index, items.length, onIndex, open]
  );

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowRight') step(1);
      if (e.key === 'ArrowLeft') step(-1);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose, step]);

  if (!open) return null;
  const item = items[index];

  return (
    <div className="lightbox" role="dialog" aria-modal="true" aria-label="Gallery">
      <button type="button" className="lightbox__scrim" onClick={onClose} tabIndex={-1} aria-hidden="true" />

      <button type="button" className="lightbox__close" onClick={onClose}>
        <Close size={22} />
        <span className="sr-only">Close</span>
      </button>

      <button type="button" className="lightbox__nav lightbox__nav--prev" onClick={() => step(-1)}>
        <ArrowRight size={20} style={{ transform: 'rotate(180deg)' }} />
        <span className="sr-only">Previous image</span>
      </button>

      <figure className="lightbox__figure">
        <img src={item.src} alt={item.alt || ''} />
        <figcaption className="lightbox__caption tabular">
          {index + 1} / {items.length}
        </figcaption>
      </figure>

      <button type="button" className="lightbox__nav lightbox__nav--next" onClick={() => step(1)}>
        <ArrowRight size={20} />
        <span className="sr-only">Next image</span>
      </button>
    </div>
  );
}
